module.exports = __webpack_public_path__ + "img/mobile-script.ce4608f1.webp";